import { Perfil, PerfilUtils } from "./Perfil";

export default interface Usuario {
    id?: string;
    username: string;
    nome?: string;
    cpf?: string;
    email: string | null;
    perfil?: Perfil;
    matricula?: string | null;
    log?: string;
}

export class UsuarioUtils {

    // Verifica se o usuário tem todas as permissões necessárias
    static verificarTodasPermissoes(usuario: Usuario, permissoesNecessarias: string[]): boolean {
        if (!usuario.perfil) return false;
        return PerfilUtils.verificarTodasPermissoes(usuario.perfil, permissoesNecessarias);
    }

    // Verifica se o usuário tem pelo menos uma das permissões necessárias
    static verificarQualquerPermissao(usuario: Usuario, permissoesNecessarias: string[]): boolean {
        if (!usuario.perfil) return false;
        return PerfilUtils.verificarQualquerPermissao(usuario.perfil, permissoesNecessarias);
    }

    // Verifica se o usuário tem todas as permissões necessárias, considerando o bancaId
    static verificarTodasPermissoesComBancaId(usuario: Usuario, permissoesNecessarias: string[], bancaId: string): boolean {
        if (!usuario.perfil) return false;
        return PerfilUtils.verificarTodasPermissoesComBancaId(usuario.perfil, permissoesNecessarias, bancaId);
    }

    // Verifica se o usuário tem pelo menos uma das permissões necessárias, considerando o bancaId
    static verificarQualquerPermissaoComBancaId(usuario: Usuario, permissoesNecessarias: string[], bancaId: string): boolean {
        if (!usuario.perfil) return false;
        return PerfilUtils.verificarQualquerPermissaoComBancaId(usuario.perfil, permissoesNecessarias, bancaId);
    }

    // Verifica se o usuário tem um perfil específico
    static verificarPerfilUsuario(usuario: Usuario, perfilNecessario: Perfil[]): boolean {
        if (!usuario.perfil) return false;
        if (perfilNecessario.length === 0) return true;
        return perfilNecessario.some(p => p.nome === usuario.perfil?.nome);
    }
}